import { render, staticRenderFns } from "./PaxelMarketSOP.vue?vue&type=template&id=09e51652&"
import script from "./PaxelMarketSOP.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketSOP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports